import { ReactNode } from 'react'

export const MainColumn = ({children}: {children: ReactNode}) => (
  <main className="flex-1 overflow-y-auto">
    <section className="flex min-h-full min-w-0 flex-1 flex-col lg:order-last">
      { children }
    </section>
  </main>
)
